import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Card } from '@themesberg/react-bootstrap';
import axiosInstance from "../../../api/api";
import DOMPurify from "quill/formats/link";

function Ranked({ field, ciemId }) {
    const [showModal, setShowModal] = useState(false);
    const [valueOption, setValueOption] = useState({
        id: '',
        value: '',
        ciemId: '',
        detailOptionId: '',
    });

    const [error, setError] = useState(null);
    const [selectedValue, setSelectedValue] = useState(1);

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const fetchData = async () => {
        try {
            console.log("option que llega");
            console.log(field);
            const datosResponse = await axiosInstance.get(`/valueoption/${field.id}/${ciemId}/`);
            const primerElemento = datosResponse.data;
            console.log("option que llega2", primerElemento.data[0]);
            setValueOption(primerElemento.data[0]);
            setSelectedValue(primerElemento.data[0].value); // Asegurar que se actualiza el select
        } catch (error) {
            console.error("Error en fetchData:", error);
            setError(error);
        }
    };

    useEffect(() => {
        if (field.id) {
            fetchData();
        } else {
            setValueOption({
                id: '',
                value: '',
                ciemId: '',
                detailOptionId: '',
            });
            setSelectedValue(1);
        }
    }, [field.id]);

    const handleSelectChange = (event) => {
        setSelectedValue(parseInt(event.target.value, 10));
    };

    const handleButtonClick = () => {
        const updatedValueOption = {
            ...valueOption,
            detailOptionId: field.id,
            ciemId: ciemId,
            value: selectedValue,
        };

        console.log("Enviando datos:", updatedValueOption);

        axiosInstance.post('/valueoption/', updatedValueOption)
            .then(response => {
                console.log("Guardado correctamente:", response.data);
                alert("Calificación guardada correctamente");
                fetchData();
            })
            .catch(error => {
                alert("Ocurrió un error -> " + error.response?.data?.message || error.message);
                console.error('Error guardando data:', error);
            });
    };


    const numbers = Array.from({ length: 10 }, (_, i) => i + 1); // Genera números del 1 al 10

    return (
        <div>
            <Form.Group className="mt-3">
                <Form.Label>Selecciona una opción</Form.Label>
                <Form.Select value={selectedValue} onChange={handleSelectChange}>
                    {numbers.map((number) => (
                        <option key={number} value={number}>{number}</option>
                    ))}
                </Form.Select>
            </Form.Group>

            <Button variant="primary" className="mt-3" onClick={handleButtonClick}>
                Guardar valor
            </Button>
        </div>
    );
}

export default Ranked;